<template>
  <div>
    <v-container fluid class="">
      <v-card>
        <v-card-title>
          Daily Timeclocks
          
          <v-toolbar flat>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title>
              <small>{{ this.momentLocal(this.date).format("MMM DD YYYY") }}</small>
            </v-toolbar-title>
            <v-btn outlined class="ml-4" color="grey darken-2" @click="today">
              Today
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <template>
          <v-card>
            <v-skeleton-loader
              v-if="timeclockLoading || loading"
              class="mx-auto"
              type="table"
            ></v-skeleton-loader>
            <v-data-table
              v-else
              :headers="headers"
              :items="formattedItems"
              show-expand
              single-expand
              class="elevation-1"
              :options.sync="tableOptions"
              :server-items-length="totalItems"
              :loading="timeclockLoading || loading"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
              }"
              :disable-pagination="true"
            >

              <template v-slot:item.employee="{ item }">
                <div>
                  <v-chip small color="teal" style="color: white">
                    {{ item.employeeFirstName + " " + item.employeeLastName }}
                  </v-chip>
                </div>
              </template>

              <template v-slot:item.startTime="{ item }">
                <span style="white-space:nowrap">
                  <span
                    v-if="item.fStartDate"
                    style="color: #424242"
                  >
                    {{ item.fStartDate }} &nbsp;
                  </span>
                    {{ item.fStartTime }}
                </span>
              </template>

              <template v-slot:item.stopTime="{ item }">
                <span style="white-space:nowrap">
                  <span v-if="item.fStopTime">
                    <span
                      v-if="item.fStopDate"
                      style="color: #424242"
                    >
                      {{ item.fStopDate }} &nbsp;
                    </span>
                      {{ item.fStopTime }}
                  </span>
                  <span v-else style="color: red">
                    Running
                  </span>
                </span>
              </template>

              <template v-slot:item.duration="{ item }">
                <v-chip small>
                  <ClockerSingle :item="item" />
                </v-chip>
              </template>

              <template v-slot:item.clientId="{ item }">
                <ClientChip
                  :clientId="item.clientId"
                  :clientName="item.clientCompanyName"
                />
              </template>

              <template v-slot:item.name="{ item }">
                <div v-if="$vuetify.breakpoint.xsOnly">
                  <span @click="onEdit(item)">{{ item.name }}</span>
                </div>
                <div
                  v-else
                  :style="nameLen">
                  <span
                    v-if="item.name.length <= 175"
                    @click="onEdit(item)"
                  >{{ item.name }}</span>
                  <v-tooltip v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        @click="onEdit(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.name.slice(0,175) + "..." }}
                      </span>
                    </template>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="mr-10 py-5"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: end;
                  "
                >
                  <div style="width: fit-content;">
                  <span class="d-flex" style="gap: 5px">
                    <h4>20min Break:</h4>&nbsp;
                    <span v-if="hasOwn(item.questionnaire, 'question1answer')">
                      {{ item.questionnaire.question1answer ? "Yes" : "No" }}
                    </span>
                    <span v-else>Unanswered</span>
                  </span>
                  <span
                    v-if="hasOwn(item.questionnaire, 'question1reason') && 
                      item.questionnaire.question1reason"
                    class="d-flex"
                    style="gap: 5px"
                  >
                    <h4>Reason:</h4>&nbsp;
                    <span>{{ item.questionnaire.question1reason }}</span>
                  </span>
                  <span class="d-flex" style="gap: 5px">
                    <h4>30min Lunch:</h4>&nbsp;
                    <span v-if="hasOwn(item.questionnaire, 'question2answer')">
                      {{ item.questionnaire.question2answer ? "Yes" : "No" }}
                    </span>
                    <span v-else>Unanswered</span>
                  </span>
                  <span
                    v-if="hasOwn(item.questionnaire, 'question2reason') &&
                      item.questionnaire.question2reason"
                    class="d-flex"
                    style="gap: 5px"
                  >
                    <h4>Reason:</h4>&nbsp;
                    <span>{{ item.questionnaire.question2reason }}</span>
                  </span>
                  </div>
                </div>
                <td v-else :colspan="headers.length" class="py-5">
                  <div
                    class="mr-10"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: end;
                    "
                  >
                    <div style="width: fit-content;">
                    <span class="d-flex" style="gap: 5px">
                      <h4>20min Break:</h4>&nbsp;
                      <span v-if="hasOwn(item.questionnaire, 'question1answer')">
                        {{ item.questionnaire.question1answer ? "Yes" : "No" }}
                      </span>
                      <span v-else>Unanswered</span>
                    </span>
                    <span
                      v-if="hasOwn(item.questionnaire, 'question1reason') && 
                        item.questionnaire.question1reason"
                      class="d-flex"
                      style="gap: 5px"
                    >
                      <h4>Reason:</h4>&nbsp;
                      <span>{{ item.questionnaire.question1reason }}</span>
                    </span>
                    <span class="d-flex" style="gap: 5px">
                      <h4>30min Lunch:</h4>&nbsp;
                      <span v-if="hasOwn(item.questionnaire, 'question2answer')">
                        {{ item.questionnaire.question2answer ? "Yes" : "No" }}
                      </span>
                      <span v-else>Unanswered</span>
                    </span>
                    <span
                      v-if="hasOwn(item.questionnaire, 'question2reason') &&
                        item.questionnaire.question2reason"
                      class="d-flex"
                      style="gap: 5px"
                    >
                      <h4>Reason:</h4>&nbsp;
                      <span>{{ item.questionnaire.question2reason }}</span>
                    </span>
                    </div>
                  </div>
                </td>
              </template>

              <template v-slot:item.questionnaire.notes="{ item }">
                <div v-if="hasOwn(item.questionnaire, 'question2reason') &&
                  item.questionnaire.notes"
                >
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                  >
                    {{ item.questionnaire.notes }}
                  </div>
                  <div
                    v-else
                    style="min-width: 25ch"
                  >
                    {{ item.questionnaire.notes }}
                  </div>
                </div>
              </template>
              
            </v-data-table>
          </v-card>
        </template>

        <TimeClockForm
          :show="showForm"
          :item="selectedItem"
          :client-id="selectedItem.clientId"
          @onClosed="clearForm()"
          @onSucceded="refresh()"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TimeClockForm from "../Task/_FormJob";
import ClientChip from "components/ClientChip";
import ClockerSingle from "@/views/Pages/Timeclock/__ClockerSingle";
import formatterMixin from "@/mixins/formatterMixin";
import _ from "lodash";

export default {
  mixins: [formatterMixin],
  components: {
    ClientChip,
    TimeClockForm,
    ClockerSingle
  },
  data: () => ({
    date: "",
    showForm: false,
    selectedItem: {},
    timer: null,
    initialPageLoad: true,
    loading: true,
    tableOptions: {},
    formattedItems: [],
    headers: [
      { text: "Employee", value: "employee", align: "start", sortable: false },
      { text: "Start", value: "startTime", align: "start", sortable: false },
      { text: "Stop", value: "stopTime", align: "start", sortable: false },
      { text: "Duration", value: "duration", align: "start", sortable: false },
      { text: "Client", value: "clientId", align: "start", sortable: false },
      { text: "Job Code", value: "taskCode", align: "start", sortable: false },
      { text: "Job Name", value: "taskName", align: "start", sortable: false },
      { text: "Notes", value: "questionnaire.notes", align: "start", sortable: false },
      { text: "", value: "data-table-expand" },
    ],
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account.data,
      timeclockLoading: (state) => state.timeclockEntry.loadingTable,
      totalItems: (state) => state.timeclockEntry.metaData.totalEntries,
      dataItems: (state) => state.timeclockEntry.data,
    }),

    computedFilter() {
      let { page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
        OrderBy: "stopTime",
        Ascending: true
      };

      const startUtc = this.date
        ? this.localToUtc(this.momentLocal(this.date).startOf("day"))
        : this.localToUtc(this.momentLocal().startOf("day"));
      const start = startUtc.format('YYYY-MM-DD[T]HH:mm:ss');
      const end = startUtc.add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');

      params.startDate = start;
      params.endDate = end;

      if (!this.hasAccess('timeClock.view')) {        
        params.employeeId = this.account.user.id;
      }

      return params;
    },

    // only set name column's length to as wide as it needs to be, up to a threshold
    nameLen() {
      const threshold = 40
      let len = 0
      this.formattedItems.forEach((item) => {
        if(item?.name?.length >= threshold) {
          len = threshold;
        } else if(item?.name?.length >= len) {
          len = item.name.length
        }
      })
      return { minWidth: len + 'ch'};
    }

  },
  watch: {
    tableOptions: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          
          // table options refresh after the first dataitems update (which sets
          // loading to false), so this prevents a hiccup in the skeleton
          // loader on initial page load
          if(this.initialPageLoad) {
            this.initialPageLoad = false;
            this.refreshNoLoading();
          } else {
            this.refresh();
          }
          
        }
      },
      deep: true,
    },

    computedFilter: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.loading = true;
          this.refresh();
        }
      },
      deep: true,
    },

    dataItems: {
      async handler(n) {
        const items = [];
        for(const i of n) {
          const displayTimes = this.getDisplayTimes(i);
          
          const item = {
            ...i,
            ...displayTimes,
          };
          items.push(item);
        }

        this.formattedItems = items.sort((a, b) => {
          // sort running timeclocks to the top of the day
          if(a.stopTime && !b.stopTime) {
            return 1;
          } else if (b.stopTime && !a.stopTime) {
            return -1;
          } else {
            return 0;
          }
        });
        this.loading = false;
      },
      deep: true,
    },
  },

  async mounted() {
    this.date = this.momentLocal().startOf("day").format();

    await this.refresh();

    this.timer = setInterval(() => {
      this.refreshNoLoading();
    }, (120 * 1000));
  },

  beforeDestroy() {
    this.clearTableFilter();
    clearInterval(this.timer);
  },

  methods: {
    ...mapActions("timeclockEntry", [
      "getAll",
      "clearTableFilter",
      "applyTableFilter",
    ]),

    refresh: _.debounce(async function () {
      this.refreshTable(true);
    }, 500),

    async refreshTable(noLoading = true) {
      this.applyTableFilter({ ...this.computedFilter, noLoading });
    },

    async refreshNoLoading() {
      if (!this.loading) {
        await this.refreshTable(false);
      }
    },

    today() {
      this.date = this.momentLocal().startOf("day").format();
    },

    prev() {
      this.date = this.momentLocal(this.date).subtract(1, "day").format();
    },

    next() {
      this.date = this.momentLocal(this.date).add(1, "day").format();
    },

    hasOwn(obj, key) {
      if(!obj){
        return false
      }
      return hasOwnProperty.call(obj, key);
    },

    onEdit(item) {
      if (!this.hasAccess("timeClock.edit")) {
        return false;
      }
      this.showForm = true;
      this.selectedItem = item;
    },

    clearForm() {
      this.showForm = false;
      this.selectedItem = {};
    },

    getDisplayTimes(timeclock) {
      const tableDate = this.date 
          ? this.momentLocal(this.date).format("YYYY-MM-DD")
          : this.momentLocal().format("YYYY-MM-DD");
        let localStart = this.momentLocal(timeclock.startTime);
        let localStop = timeclock.stopTime
          ? this.momentLocal(timeclock.stopTime)
          : null;

        // e.g., if showing Jan 1st and start time is Dec 31st...
        // 12/31 10:00am – 11:00am
        let startDate = ""
        if(localStart && localStart.format("YYYY-MM-DD") !== tableDate) {
          startDate = localStart.format("M/D");
        }
        let stopDate = ""
        if(localStop && localStop.format("YYYY-MM-DD") !== tableDate) {
          stopDate = localStop.format("M/D");
        }
        let startTime = this.momentLocal(timeclock.startTime).format("h:mma");
        let stopTime = localStop
          ? this.momentLocal(timeclock.stopTime).format("h:mma")
          : "";

        // 12/31 10am – 11am
        startTime = startTime.replace(":00", "");
        stopTime = stopTime.replace(":00", "");
        
        return {
          fStartDate: startDate,
          fStartTime: startTime,
          fStopDate: stopDate,
          fStopTime: stopTime,
        }
    },
  },
};
</script>
